module.exports = __webpack_public_path__ + "img/folder.ab4845cd.svg";